/**
 * S60b — socket subscription for the analysis run panel (§10.2).
 */
import { subscribe, isSocketOpen } from './socket.js';

/**
 * Subscribe to analysis:step / analysis:status for one run.
 * @param {string} runId
 * @param {{ onStep?: (step: object) => void, onStatus?: (payload: object) => void }} handlers
 * @returns {() => void}
 */
export function subscribeAnalysis(runId, handlers) {
  const id = String(runId || '');
  if (!id) return () => {};
  return subscribe((packet) => {
    if (!packet || typeof packet !== 'object') return;
    const event = packet.event || '';
    const data = packet.data && typeof packet.data === 'object' ? packet.data : {};
    if (String(data.run_id || '') !== id) return;
    if (event === 'analysis:step' && handlers && typeof handlers.onStep === 'function') {
      if (data.step && typeof data.step === 'object') handlers.onStep(data.step);
      return;
    }
    if (event === 'analysis:status' && handlers && typeof handlers.onStatus === 'function') {
      handlers.onStatus(data);
    }
  });
}

export { isSocketOpen };
